/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const containerStyles = css({
	display: 'flex',
	paddingTop: token('space.200'),
	paddingBottom: token('space.200'),
});

const lineStyles = css({
	display: 'flex',
	boxSizing: 'border-box',
	height: '1px',
	width: '100%',
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: token('color.border'),
});

const Line = () => (
	<div css={containerStyles}>
		<div css={lineStyles} />
	</div>
);

export default Line;
